module.exports = __webpack_public_path__ + "img/silogues-beta-logo.752e89b5.svg";